import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import EmailIcon from "@mui/icons-material/Email";
import SaveIcon from "@mui/icons-material/Save";

const BottomBar = ({
  loading,
  scannedCount,
  saveMappingSending,
  onScanClick,
  onEmailClick,
  onSaveClick,
}) => (
  <Box
    sx={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      px: 2,
      pt: 1.5,
      pb: 2,
      bgcolor: "#f0f4f8",
      borderTop: "1px solid #dde3eb",
      boxShadow: "0 -4px 16px rgba(0,0,0,0.08)",
      display: "flex",
      flexDirection: "column",
      gap: 1,
    }}
  >
    <Button
      variant="contained"
      size="large"
      fullWidth
      startIcon={
        loading ? (
          <CircularProgress size={22} sx={{ color: "#fff" }} />
        ) : (
          <QrCodeScannerIcon />
        )
      }
      disabled={loading}
      onClick={onScanClick}
      sx={{
        py: 1.8,
        mb: 1,
        fontSize: "1.05rem",
        fontWeight: 700,
        borderRadius: 3,
        bgcolor: "#0563B0",
        "&:hover": { bgcolor: "#044a8a" },
        "&.Mui-disabled": { bgcolor: "#90b8d8" },
        boxShadow: "0 4px 16px rgba(5,99,176,0.4)",
        direction: "ltr",
      }}
    >
      {loading ? "מעבד..." : "סרוק קוד QR"}
    </Button>
    <Box sx={{ display: "flex", gap: 1 }}>
      <Button
        variant="outlined"
        size="large"
        startIcon={<EmailIcon />}
        onClick={onEmailClick}
        sx={{
          flex: 1,
          py: 1.4,
          fontSize: "0.95rem",
          fontWeight: 700,
          borderRadius: 3,
          borderColor: "#0563B0",
          color: "#0563B0",
          bgcolor: "#fff",
          "&:hover": { bgcolor: "#e8f0fb", borderColor: "#044a8a" },
          direction: "ltr",
        }}
      >
        שלח דוח במייל
      </Button>
      {scannedCount > 0 && (
        <Button
          variant="outlined"
          size="large"
          startIcon={
            saveMappingSending ? (
              <CircularProgress size={16} sx={{ color: "#2e7d32" }} />
            ) : (
              <SaveIcon />
            )
          }
          onClick={onSaveClick}
          disabled={saveMappingSending}
          sx={{
            flex: 1,
            py: 1.4,
            fontSize: "0.95rem",
            fontWeight: 700,
            borderRadius: 3,
            borderColor: "#2e7d32",
            color: "#2e7d32",
            bgcolor: "#fff",
            "&:hover": { bgcolor: "#e8f5e9", borderColor: "#1b5e20" },
            "&.Mui-disabled": { bgcolor: "#e8f5e9", borderColor: "#81c784" },
            direction: "ltr",
          }}
        >
          {saveMappingSending ? "שומר..." : "שמור מיפוי"}
        </Button>
      )}
    </Box>
  </Box>
);

export default BottomBar;
